import type { Palette } from '@mui/material/styles';
import type { SimplePaletteColorOptions } from '@mui/material/styles/createPalette';
import { rgba } from 'polished';
import styled, { type DefaultTheme } from 'styled-components';
import type { IndicatorColor } from './types';

function isValidPalette(palette: unknown): palette is SimplePaletteColorOptions {
  return typeof palette === 'object' && !!palette && 'main' in palette && 'contrastText' in palette;
}

function getColourPalette(p: { color: string; theme: DefaultTheme }) {
  if (!p.color) {
    return undefined;
  }
  const colour = p.color as keyof Palette;
  return p.theme.palette[colour];
}

function backgroundColour(p: { color: string; theme: DefaultTheme }): string {
  const palette = getColourPalette(p);
  if (!p.color || !isValidPalette(palette)) {
    return p.theme.palette.common.black;
  }
  return palette.main;
}

function textColour(p: { color: string; theme: DefaultTheme }): string {
  const palette = getColourPalette(p);
  if (!p.color || !isValidPalette(palette)) {
    return p.theme.palette.common.white;
  }
  return palette.contrastText;
}

export const IndicatorBadge = styled('div')<{ color: IndicatorColor }>`
  padding: ${(p) => p.theme.spacing(0, 1)};
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  background-color: ${backgroundColour};
  border-radius: ${(p) => p.theme.shape.borderRadius * 2}px;
  border: 1px solid ${(p) => rgba(backgroundColour(p), 0.13)};
  color: ${textColour};
  font-size: 12px;
  line-height: 20px;
`;

export const IndicatorDot = styled('div')<{ color: IndicatorColor }>`
  display: inline-flex;
  min-height: 16px;
  min-width: 16px;
  background-color: ${backgroundColour};
  border-radius: 50%;
  border: 1px solid ${({ theme }) => rgba(theme.palette.evnex.main, 0.13)};
  color: ${textColour};
`;

export const IconWrapper = styled('span')`
  margin-right: ${(p) => p.theme.spacing(0.5)};
  display: inline-flex;

  svg {
    font-size: 14px;
  }
`;
